import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./../../../styles/login/portal/consultas.css";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { BaseUrlInfo, BaseUrlServ } from "../../../services/axios/AxiosEndpoints";
import {
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
} from "@mui/material";
import styled from "@emotion/styled";
import DOMPurify from "dompurify";
import printJS from "print-js";
import { CleanReprintReportData, ReprintReportData } from "../../../reducers/reports/reprintreport";
import { Link } from "react-router-dom";
import ReprintTicketReport from "../PrintFiles/ReprintTicketReport";

const SearchConsult = () => {
  /* --------------------------------- Datos del usuario y de respuesta del servidor ------------------------------ */

  /* Variable que almacena los datos */
  const [Datos, setDatos] = useState({});
  /* Variable que almacena los mensajes de errores */
  const [Posterror, setPosterror] = useState({});
  /* Variable que almacena el codigo de la autorizacion */
  const [AuthCod, setAuthCod] = useState();
  /* Datos almacenados en redux */
  const { coberturas } = Datos;
  /* Datos almacenados en redux */
  const { usuario, clave, codPss } = useSelector((state) => state.user);
  /* Variable para disparar funciones de redux */
  const dispatch = useDispatch();

  /* --------------------------------- Estilos de la tabla ------------------------------ */

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#46cffa",
      color: "#fff",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
    },
  }));

  const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f5f5",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  /* --------------------------------- Datos de la tabla ------------------------------ */

  const columns = [
    { id: "codigo", label: "Código Servicios", Width: "auto" },
    { id: "nombre", label: "Nombre Servicios.", Width: "auto" },
    { id: "montoReclamado", label: "Valor del Servicio", Width: "auto" },
    { id: "montoARS", label: "Cobertura ARS", Width: "auto" },
    { id: "montoAseg", label: "Diferencia Afiliado", Width: "auto" },
  ];

  /* --------------------------------- Paginación de la tabla  ------------------------------ */

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* --------------------------------- Valida el campo del codigo de autorización  ------------------------------ */

  const validate = (values) => {
    const errors = {};

    if (!values.codAutorizacion) {
      errors.codAutorizacion = "Este campo no puede estar vacio";
      Swal.fire({
        title: "",
        text: errors.codAutorizacion,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }

    return errors;
  };

  /* ---------------------------------  Formulario para realizar la consulta y mostrar los datos en la tabla ------------------------------ */

  const formik = useFormik({
    initialValues: {
      usuario: usuario,
      password: clave,
      codPss: codPss,
      codAutorizacion: "",
    },

    validate,

    onSubmit: async (values) => {
      const sanitizedCodAuth = parseInt(
        DOMPurify.sanitize(values.codAutorizacion)
      );

      await axios({
        url: `${BaseUrlInfo}/getDetalleAutorizacion`,
        method: "POST",
        data: JSON.stringify({
          auth: {
            usuario: values.usuario,
            password: values.password,
            codPss: values.codPss,
          },
          codAutorizacion: sanitizedCodAuth,
        }),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setDatos(response.data);
            setAuthCod(values.codAutorizacion);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              //setMensajeOk("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              //setMensajeOk("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;
            setPosterror(resp.mensaje);
            Swal.fire({
              title: "",
              text: "código no autorizado o invalido",
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    },
  });

  /* ------------------------------------ Funciones para crear e imprimir el ticket ------------------------------------ */

  const imprimirContenido = () => {
    printJS({
      printable: "contenidoParaImprimir",
      // ID del elemento que deseas imprimir
      type: "html",
    });
  };

  /* ------------------------------------ Funciones para crear e imprimir el reporte ------------------------------------ */

  useEffect(() => {
    if (AuthCod) {
      axios({
        url: `${BaseUrlServ}/ObtenerDatosReimprimir`,
        method: "POST",
        headers: {
          Accept: "*/*",
        },
        params: {
          codaut: AuthCod,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            dispatch(
              ReprintReportData({
                reprintdata: response.data,
              })
            );
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              //setMensajeOk("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              //setMensajeOk("Ha ocurrido un error en el servidor");
            }

            const { resp } = error.response.data;

            setPosterror(resp.mensaje);
            Swal.fire({
              title: "",
              text: "código no autorizado o invalido",
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
          }
        });
    }
  }, [AuthCod, dispatch]);

  /* --------------------------------- Formulario para refrescar la pantalla, imprimir el PDF y borrar los datos ------------------------------ */

  const HandleRefreshAfterPDF = () => {
    setDatos({})

    setTimeout(() => {
      window.location.reload();

      dispatch(
        CleanReprintReportData({
          reprintdata: Datos,
        })
      );
    }, 3000);
  };

  /* --------------------------------- Formulario para refrescar la pantalla, imprimir el Ticket y borrar los datos ------------------------------ */

  const HandleRefreshAfterTicket = () => {
    Swal.fire({
      title: "IMPRIMIR TICKET",
      text: "En caso de cancelar la impresión, vuelva a realizar la consulta con el código de autorización para re-imprimir el ticket.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "NO",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        imprimirContenido();

        setDatos({})

        setTimeout(() => {
          window.location.reload();
    
          dispatch(
            CleanReprintReportData({
              reprintdata: Datos,
            })
          );
        }, 3000);
      }
    });
  };

  /* --------------------------------- ------------------------------ */

  return (
    <Container maxWidth="lx">
      <div className="contenedor-central">
        <div className="container p-0 m-0 ">
          <div className="container p-0 m-0">
            <h5 className="text-center mt-5 ">CONSULTAR AUTORIZACIONES</h5>

            <div className="container p-0 m-0 mt-5 ">
              <div className="row flex-row justify-content-center p-0 m-0 ">
                <div className="col-auto ">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row d-flex flex-row justify-content-center ">
                      <div className="col-auto p-0 m-0 ">
                        <TextField
                          size="small"
                          id="search"
                          className="form-control "
                          type="text"
                          placeholder="NÚMERO DE AUTORIZACIÓN"
                          aria-label="Search"
                          name="codAutorizacion"
                          value={formik.values.codAutorizacion}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: {
                              xs: "100%",
                              sm: "100%",
                              md: "400px",
                              lg: "400px",
                            },
                          }}
                        />
                        {formik.touched.codAutorizacion &&
                        formik.errors.codAutorizacion ? (
                          <div className="col-auto errorlabel mt-3">
                            {formik.errors.codAutorizacion}
                          </div>
                        ) : null}

                        {Posterror.detalle && Posterror.detalle ? (
                          <div className="col-auto errorlabel mt-3">
                            {Posterror.detalle}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-auto  ">
                        <Button
                          variant="contained"
                          color="success"
                          type="submit"
                          sx={{
                            marginTop: {
                              xs: "10px",
                              sm: "10px",
                              md: "0px",
                              lg: "0px",
                            },
                            marginBottom: "10px",
                          }}
                        >
                          BUSCAR
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="row d-flex justify-content-end ">
                <Typography
                  sx={{
                    width: "auto",
                    marginTop: {
                      xs: "10px",
                      sm: "10px",
                      md: "10px",
                      lg: "10px",
                    },
                    marginRight: "20px",
                    fontWeight: "bold",
                  }}
                >
                  RE-IMPRESIÓN DE REPORTES
                </Typography>
              </div>

              <div className="row d-flex justify-content-end ">
                {!AuthCod ? (
                  <>
                    <Button
                      variant="contained"
                      //onClick={imprimirContenido}
                      sx={{
                        width: "auto",
                        marginTop: {
                          xs: "10px",
                          sm: "10px",
                          md: "20px",
                          lg: "20px",
                        },
                        marginRight: "25px",
                      }}
                    >
                      TICKET
                    </Button>

                    <Button
                      variant="contained"
                      //type="submit"
                      sx={{
                        width: "auto",
                        marginTop: {
                          xs: "10px",
                          sm: "10px",
                          md: "20px",
                          lg: "20px",
                        },
                        marginRight: "25px",
                      }}
                    >
                      REPORTE
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      onClick={HandleRefreshAfterTicket}
                      color="success"
                      type="button"
                      sx={{
                        width: "auto",
                        marginTop: {
                          xs: "10px",
                          sm: "10px",
                          md: "20px",
                          lg: "20px",
                        },
                        marginRight: "25px",
                      }}
                    >
                      TICKET
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      type="button"
                      onClick={HandleRefreshAfterPDF}
                      sx={{
                        width: "auto",
                        marginTop: {
                          xs: "10px",
                          sm: "10px",
                          md: "20px",
                          lg: "20px",
                        },
                        marginRight: "25px",
                      }}
                    >
                      <Link
                        to="/reprintreport"
                        className="btn text-white bold"
                        target="/blank"
                        style={{ fontSize: 14 }}
                      >
                        REPORTE
                      </Link>
                    </Button>
                  </>
                )}

                <div className="d-none">
                  <ReprintTicketReport imprimirContenido={imprimirContenido} />
                </div>
              </div>

              <div className="row d-flex justify-content-center p-0 m-0">
                <div className="col-auto p-0 m-0">
                  <Paper
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      marginTop: "40px",
                    }}
                  >
                    <TableContainer sx={{ maxHeight: 600 }}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <StyledTableRow>
                            <StyledTableCell
                              style={{ width: "10%", fontSize: 13 }}
                            >
                              NÚMERO DE AUTORIZACIÓN
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "10%", fontSize: 13 }}
                            >
                              FECHA
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "15%", fontSize: 13 }}
                            >
                              PÓLIZA
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "15%", fontSize: 13 }}
                            >
                              CÓDIGO SERVICIO SALUD
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "25%", fontSize: 13 }}
                            >
                              NOMBRE SERVICIO SALUD
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "auto", fontSize: 13 }}
                            >
                              VALOR DEL SERVICIO
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "auto", fontSize: 13 }}
                            >
                              COBERTURA ARS
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ width: "auto", fontSize: 13 }}
                            >
                              DIFERENCIA AFILIADO
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableHead>
                        <TableBody>
                          {coberturas
                            ?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((coberturas) => {
                              return (
                                <StyledTableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={coberturas.code}
                                >
                                  <TableCell>{Datos.codAutorizacion}</TableCell>
                                  <TableCell>{Datos.fecha}</TableCell>
                                  <TableCell>{Datos.plastico}</TableCell>
                                  {columns.map((column) => {
                                    const value = coberturas[column.id];
                                    return (
                                      <>
                                        <TableCell
                                          key={column.id}
                                          align={column.align}
                                        >
                                          {column.format &&
                                          typeof value === "number"
                                            ? column.format(value)
                                            : value}
                                        </TableCell>
                                      </>
                                    );
                                  })}
                                </StyledTableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 100]}
                      component="div"
                      count={coberturas?.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </div>
              </div>
            </div>
          </div>

          <footer className="py-4 ">
            <div className="container p-0 m-0">
              <div className="d-flex align-items-center justify-content-center small">
                <div className="text-muted">Copyright © ARS RENACER 2023</div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </Container>
  );
};

export default SearchConsult;
